module.exports = __webpack_public_path__ + "static/smothii-f73023218e8cf756dc1499d6cc64ebed.webp";